import React, { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import * as cardsModule from "../components/card-data";

// Normalize card-data export
function getCardsArray(mod) {
  const candidate =
    mod?.default ??
    mod?.cardData ??
    mod?.cards ??
    mod?.data ??
    null;

  if (Array.isArray(candidate)) return candidate;
  if (candidate && typeof candidate === "object") return Object.values(candidate);

  const firstArray = Object.values(mod || {}).find(Array.isArray);
  return Array.isArray(firstArray) ? firstArray : [];
}

// Hook to read query param
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SearchResults() {
  const query = useQuery().get("query") || "";
  const allCards = useMemo(() => getCardsArray(cardsModule), []);

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];

    return allCards
      .filter((c) => c?.name && c.name.toLowerCase().includes(q))
      .map((c) => ({
        name: c.name,
        slug: c.slug?.startsWith("/") ? c.slug : `/tarot/${c.slug || ""}`,
        image: c.image || c.img || c.thumbnail || "",
      }));
  }, [query, allCards]);

  return (
    <div className="max-w-screen-lg mx-auto p-4 font-[Cormorant_Garamond] text-[#3f2d61]">
      <h1 className="text-2xl font-semibold mb-4">Search Results for "{query}"</h1>
      {results.length === 0 ? (
        <p>No results found.</p>
      ) : (
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {results.map((item, idx) => (
            <li key={idx} className="border border-[#e6dff5] rounded-lg overflow-hidden shadow-sm">
              <Link to={item.slug} className="block hover:shadow-md transition">
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-40 object-contain bg-white"
                  />
                )}
                <div className="p-2 text-center">{item.name}</div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
